module.exports = __webpack_public_path__ + "static/media/study 220613.de45c408.png";